import React from 'react';
import { Input, Button } from 'components';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { Colors, Globals } from 'utils';
import { RouteComponentProps } from 'react-router';
import { SanService } from 'services';
import { LoginPig, BgLogin, LogoWhite } from 'assets/img';
import queryString from 'query-string';

interface Props extends RootState, RouteComponentProps<any> {
	dispatch: any
}

class PaymentLink extends React.Component<Props> {

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Enlace de Pago',
				onBack: null
			}
		});

		this.load();
	}

	load = async () => {
		const params = queryString.parse(this.props.location.search);
		if (!params?.code) {
			this.props.history.replace('/');
			return;
		}
		const res: any = await SanService.checkLink({
			code: params?.code
		});
		if (res.chinchin_url) {
			window.location.href = res.chinchin_url;
		}
		else {
			this.props.history.replace('/');
			Globals.showError("El enlace ya no se encuentra disponible. Por favor, entre a la aplicación para crear un nuevo enlace de pago");
		}
	}
	
	render() {
		return (
			<div id="login">
				<div className="container-black">
					<div className="row container-form container-bg" style={{ backgroundImage: `url(${ BgLogin })` }}>
						<div className="col-lg-6 container-success-payment">
							<img src={ LogoWhite } className="logo-password" />
						</div>
						<div className="col-lg-6 text-center">
							<div className="form-align">
								<img src={ LoginPig } className="pig" />
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default connect()(PaymentLink);